import { useAppSelector } from '../../../../../config/hooks';
import { getBasket } from '../../../../../redux/selectors/basketSelector';
import YourOrderInfoBE from './YourOrderInfoBE';
import RecalculatePriceLoader from '../RecalculatePriceLoader';
import useCalculateCartPrice from '../../../../../services/hook/calculatePrices/useCalculateCartPrice.hook';

const YourOrderInfo = () => {
  const { isFetching, prices } = useCalculateCartPrice();

  const basket = useAppSelector(getBasket);

  return (
    <>
      <RecalculatePriceLoader isFetching={isFetching} />

      {prices && <YourOrderInfoBE basket={basket} prices={prices.items} />}
    </>
  );
};

export default YourOrderInfo;
